<script> 
    import apigeneric from "@/helpers/apigeneric";
    export default { 
      mixins: [ apigeneric],
      data() {
        return { 
            LinksData: {},
            LinksTitle: {},
            Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
        };
      },
      components: { 
      }, 
      methods: { 
        Get(){
            let Page = {
          PageNumber: "1",
          PageSize: "9999",
          PageDataSize: "1", 
        };  
            this.ActionsFilterGet({
            Service: "Links",
            Page: Page,
            Filter:"&Linkcategory=1&Websiteid="+window.$cookies.get("ecampuswebsite"),
          }).then((res) => {
            this.LinksData = res.Data; 
          });

          
        }
      },
    };
    </script>
    <style>
         #link a {
    display: block;
    background: #c8c8c8;
    height: 100%;
    text-align: center;
    border-radius:5px
  }

  #link a:hover {
    background: #f8f8f8;
    border-radius:5px
  }
    </style>
    
    <template > 
          <section style="background-color: #dbe7ec;" >

         <div class="title c-flex"> 
                <h4 class="mt-3" >{{$t("dashboards.LinksTitle")}}</h4>
            </div>
                <div class="container" id="link" >
                    <div class="row">
                        <div class="col-md-3" v-for="(Data,index) in LinksData" :key="index"  >
                            <div class="social-item" style="height:50px; width:300px; margin-top: 20px" >
                                <div class="title mx-auto">
                                <a :href="Data.Url" class="card-link" :target="Data.Target">
                                    <p style="color:#00516a; font-family: Sans-serif;"> {{Data.Title}}</p>
                                </a>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>

            
    

        </section>
    </template>

    
    